<template>
  <div class="login-wrap">
    <NavHeaderBar title="登陆" leftArrow rightArrow />
    <div class="logo-wrap">
      <img :src="require('@/assets/img/logo.png')" alt="logo" class="logo" />
    </div>
    <div class="title">药大咖登录</div>

    <van-form
      class="form-wrap"
      ref="form"
      :show-error="false"
      @submit="onSubmit"
      validate-trigger="onSubmit"
    >
      <van-field
        v-model="mobile"
        type="tel"
        name="mobile"
        left-icon="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAA1CAMAAAATSsnTAAAAeFBMVEUAAAAAAAAgICAqKiowMDAzMzMxMTEwMDAuLi4wMDAvLy8xMTEzMzMxMTEyMjIxMTEyMjIzMzMyMjIyMjIyMjIyMjIzMzMzMzMzMzMyMjIyMjIyMjIyMjIzMzMzMzMzMzMzMzMyMjIzMzMyMjIyMjIzMzMzMzMzMzO+js0/AAAAJ3RSTlMAAggMEBQfICcwPENLY2dobG91dnt/h4ibn6+zu7/T19jf4+/z9/tdej+yAAAAl0lEQVQ4y+3Pyw6CMBCF4QMo5aZ4a0WtIBR63v8N3WgIkTZx3383ky+TDIBSGzoyugQASXLoVxtISqDiVMdwFNcTK2ge4OlIjZGJjyQcQc5zlAohhBBpNO/IBXl9P+mc5Pr8pJxkrUACCSSQQH7I+bbo9NcVw41PbGnw4MVHJO8orFWZC2TK2gLYW3qyOwDIm7Z31DY58Ab3kDNtjXYUWQAAAABJRU5ErkJggg=="
        placeholder="请输入手机号"
        :rules="[
          {
            pattern: /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/,
            message: '请填写正确的手机号'
          }
        ]"
        :border="false"
      />
      <van-field
        v-model="vcode"
        type="text"
        name="vcode"
        left-icon="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAxCAMAAABu8kCBAAABhlBMVEUAAAAAAAAAAAAAAAAzMzMqKiokJCQgICAcHBwaGhoqKionJyckJCQrKysoKCgmJiYxMTEuLi4qKioqKiopKSkwMDAuLi4tLS0yMjIuLi4tLS0yMjIyMjIxMTEwMDAvLy8xMTExMTEyMjIxMTEvLy8yMjIxMTExMTEwMDAvLy8xMTEwMDAxMTExMTExMTEwMDAyMjIxMTEwMDAyMjIyMjIxMTEyMjIxMTExMTEwMDAzMzMxMTExMTEzMzMyMjIzMzMxMTEzMzMyMjIyMjIxMTEzMzMxMTEyMjIyMjIxMTEzMzMyMjIyMjIyMjIxMTEyMjIyMjIxMTEyMjIyMjIyMjIxMTEyMjIzMzMxMTEyMjIyMjIzMzMzMzMyMjIzMzMyMjIzMzMyMjIyMjIzMzMyMjIyMjIzMzMzMzMyMjIyMjIyMjIyMjIzMzMyMjIyMjIzMzMzMzMyMjIyMjIyMjIzMzMyMjIzMzMzMzMyMjIyMjIzMzMzMzMyMjIyMjIyMjIzMzMzMzMzMzMsqNDTAAAAgXRSTlMAAgMEBQYHCAkKDA0OEhMUFRYYHh8gISgpLC0uMzQ1PD4/QkNGR0lOUFFUVVhZXmBgYmRlZ2hsbW5vb3d4foCDh4ePk5aXm5+kpaWnqKmsrK2xsbK0trm5uru9vr/Aw8fJ0NLT1dbY2drb3+Hh5OXn6Onq7O3w8fLz9Pb3+Pn6+/zdS7y4AAABZUlEQVQ4y9WUVVdCURCFRzHA7sBW7O5CRbFbsUWxscXCFr9/7puLi/d6ePBB99ue9Z2Y2WcdEY0sVc4dPxxONKeJsRL67gBeAZjIMcJsPgIrHVYRyWgY9/PeH6mLtcKm9cslj7yxYNbBunjr1BSKLlj+DpbxXBFSSj9nNBSLu6bn29qsB8pCSgMs6tyljaMI7XZP71l6ve1SrfH1zOvOoCXkmCnqdLm4wGN0sD/DIKcd8oIttwYZjVEf5JI4NeSaglzmH+aiCuyOYe4d+tpjyWG3mkRS7lHLFy8uDuwqHeISEKViuRLDDjRx8e+41JMPAvsxKi7mBjxwrOL6WY0VyxbtCm6DQhGxMang3OSLiI05BTfItIis0avgEh+ok24uzaq51OKVa4qV84vwUoMnjDzcNOL+RW6NWWbC4JqAynDeS7mj9D++Z78aM+EXD0MlKjnZlqKXMP6XxwKRXOe6+2etO7PlE/pxx8IeHg5sAAAAAElFTkSuQmCC"
        placeholder="验证码"
        :rules="[{ required: true, message: '请填写验证码' }]"
        :border="false"
      >
        <template #button>
          <!-- <van-button size="small" type="primary">获取验证码</van-button> -->
          <span style="font-size: 13px;color: #999999" @click="onClickCaptch()">
            | 获取验证码
            {{ captchaDisabledOverTime && captchaDisabledOverTime + "s" }}</span
          >
        </template>
      </van-field>
      <div style="margin-top: 16px;">
        <van-button block type="info" native-type="submit">登录</van-button>
      </div>
    </van-form>

    <van-popup
      v-model="showPopup"
      closeable
      close-icon="close"
      :close-on-click-overlay="false"
      ><div class="inner">
        <div class="title-bar">
          <h1 class="title-msg">温馨提示</h1>
          <h2 class="title-desc">
            亲，您的手机号暂未注册，请按照如下方法进入微信继续操作
          </h2>
        </div>

        <div class="content-bar">
          <div class="itemone">
            <p class="item-title">方法一</p>
            <p class="item-desc">长按并复制以下网址前往微信中打开</p>
            <div class="item-url">
              <span id="copy-txt">{{ BaserOrigin }}</span>
            </div>
            <van-button type="info" @click="copyTXT">复制</van-button>
          </div>

          <div class="itemone">
            <p class="item-title">方法二</p>
            <p class="item-desc">
              点击浏览器<b style="color: #306FF2">分享按钮</b>，选择<b
                style="color: #306FF2"
                >分享至微信</b
              >
            </p>
          </div>
        </div>
      </div></van-popup
    >
  </div>
</template>

<script>
import { mapActions } from "vuex";
import captcha from "@/mixins/captcha";
import { Toast } from "vant";
import { BaserOrigin } from "@/config/consts";
export default {
  mixins: [captcha],
  namer: "Login",
  data() {
    return {
      mobile: "",
      vcode: "",
      showPopup: false
    };
  },
  computed: {
    BaserOrigin() {
      return BaserOrigin;
    }
  },
  methods: {
    ...mapActions({
      fetchPhoneLogin: "user/fetchPhoneLogin"
    }),
    onSubmit(values) {
      const { target } = this.$route.query;
      console.log(target);
      this.fetchPhoneLogin({ params: values, target: target || "/" });
    },
    async onClickCaptch() {
      this.$refs.form
        .validate("mobile")
        .then(() => {
          this.onClickGetCaptcha(this.mobile, 1);
        })
        .catch(err => {
          console.log(err);
        });
    },
    copyTXT() {
      let copyDOM = document.querySelector("#copy-txt"); //指定的DOM元素
      let range = document.createRange(); // 创建容器
      range.selectNode(copyDOM); // 选中需要复制的节点
      window.getSelection().addRange(range); // 执行选中元素
      let successful = document.execCommand("copy"); // 执行 copy 操作
      try {
        if (successful) {
          Toast.success("复制成功");
        }
      } catch (err) {
        Toast.fail("复制失败");
      }
      window.getSelection().removeAllRanges(); // 移除选中的元素
    }
  }
};
</script>

<style lang="scss">
.login-wrap {
  .logo-wrap {
    text-align: center;
    margin-top: 96px;
    .logo {
      display: inline-block;
      width: 74px;
      height: 74px;
    }
  }
  .title {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    margin-top: 17px;
  }

  .form-wrap {
    padding: 32px;
    .van-cell {
      opacity: 1;
      border-radius: 5px;
      background: #f8f8f8;
      margin-bottom: 15px;
    }
  }
  .other-login {
    margin-top: 92px;
    .desc {
      width: 90px;
      text-align: center;
      margin: 0 auto;
      color: #999999;
      position: relative;
      &::before {
        content: "";
        width: 29px;
        height: 0px;
        border: 1px solid #999999;
        position: absolute;
        top: 5px;
        left: -40px;
      }
      &::after {
        content: "";
        width: 29px;
        height: 0px;
        border: 1px solid #999999;
        position: absolute;
        top: 5px;
        right: -40px;
      }
    }
    .pic-btns {
      text-align: center;
      margin-top: 23px;
      .icon {
        display: inline-block;
        width: 30px;
        margin: 0 10px;
      }
    }
  }

  .van-popup {
    background: transparent;
    .van-popup__close-icon {
      color: #ffffff;
    }
    .van-popup__close-icon--top-right {
      top: 40px;
      right: 10px;
    }
    .inner {
      .title-bar {
        width: 294px;
        height: 141px;
        background: url("../assets/img/gr977.png") no-repeat;
        background-size: 100% 100%;
        .title-msg {
          height: 27px;
          font-size: 19px;
          font-weight: 500;
          line-height: 27px;
          color: #fefeff;
          margin: 0 auto;
          padding-top: 52.54px;
          text-align: center;
        }
        .title-desc {
          font-size: 13px;
          line-height: 18px;
          color: #c5d8ff;
          padding: 10px 39px 0;
        }
      }
      .content-bar {
        background-color: #ffffff;
        .van-button {
          width: 220px;
          height: 35px;
          margin-top: 10px;
          border-radius: 5px;
        }
        .itemone {
          width: 100%;
          text-align: center;
          padding: 15px 20px;
          box-sizing: border-box;
          border-bottom: 1px solid #e4e4e4;
          .item-title {
            font-size: 13px;
            font-weight: bold;
            line-height: 19px;
            color: #333333;
          }
          .item-desc {
            font-size: 13px;
            line-height: 20px;
            color: #999999;
            padding-top: 8px;
          }
          .item-url {
            max-width: 211px;
            font-size: 13px;
            word-break: break-all;
            border-radius: 2px;
            line-height: 19px;
            background: rgba(48, 111, 242, 0.08);
            margin: 0 auto;
            margin-top: 5px;
            padding: 5px;
            color: #306ff2;
          }
        }
      }
    }
  }
}
</style>
